'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const FilterIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="FilterIcon">
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.457031 2.67444H14.5445"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.95703 5.89125H13.0433"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.44727 12.3256H9.55464"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.45703 9.10812H11.5433"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeWidth="0.625"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

FilterIcon.propTypes = {
  sx: PropTypes.object
}
